import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Unhandled UI error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <main style={{ padding: '4rem 1.5rem', textAlign: 'center' }}>
          <h1>Something went wrong</h1>
          <p>Please refresh the page. If the problem continues, contact me by email.</p>
        </main>
      );
    }

    return this.props.children;
  }
}
